import NewUserModule from './NewUser.module';

export * from './NewUserModuleProps';
export default NewUserModule;
